import { render, staticRenderFns } from "./HeaderSidebar.vue?vue&type=template&id=23b2ccea&scoped=true"
import script from "./HeaderSidebar.js?vue&type=script&lang=js&external"
export * from "./HeaderSidebar.js?vue&type=script&lang=js&external"
import style0 from "./HeaderSidebar.scss?vue&type=style&index=0&id=23b2ccea&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b2ccea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Icon/Icon.vue').default,HotLink: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Link/Link.vue').default,HotButton: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Button/Button.vue').default})
